/**
 * toaster.tsx — app toast surface, backed by Sonner (T-083 / BEAD-0039).
 *
 * Replaces the former hand-rolled ToastProvider/useToast/showToast. Sonner gives a
 * polished, maintained toast (smooth enter/exit, stacking, swipe/close, per-toast
 * auto-dismiss) while preserving every behaviour the T-082 review fix-forwards landed:
 *
 *   - F7 dedupe          → pass a stable `id`; a repeat call updates the live toast
 *                          in place instead of stacking a dozen identical errors.
 *   - F7 auto-dismiss    → pass `duration` (ms); the notice can't linger forever.
 *   - F3/F4 retry action → pass `action: { label, onClick }`; the call site keeps its
 *                          retryRef indirection so Retry always targets the CURRENT
 *                          location (that logic lives in the layer, not here).
 *
 * `toast` is re-exported so call sites depend on this module, not Sonner directly —
 * the library boundary stays in one file and is trivially swappable/mocked.
 *
 * Theme: the app renders light at runtime (no dark-mode toggle is wired yet, though
 * `.dark` tokens exist), so the Toaster is pinned to `light` for visual consistency;
 * `richColors` supplies Sonner's finished error treatment. When a dark-mode toggle is
 * added, switch `theme` to follow it.
 */
import { Toaster as SonnerToaster, toast } from 'sonner'

export function AppToaster() {
  return <SonnerToaster position="bottom-right" theme="light" richColors closeButton />
}

export { toast }
